import { render, staticRenderFns } from "./MenuEditBasicInfo.vue?vue&type=template&id=0bd37e3e&lang=html&"
import script from "./MenuEditBasicInfo.vue?vue&type=script&lang=js&"
export * from "./MenuEditBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports